export default {
    employeeFiledClaims: [],
    employeeFiledClaimsDetails: [],
    
    claimsDetails: [],
    
    reviewer: [],
    approver: [],
    photoUpload:[]
}